import { createSelector } from 'reselect';
import appSelector from './app';
import { EDIT_STATUS_NEW } from '../const';

const DEFAULT = EDIT_STATUS_NEW;

const editStatus = createSelector(appSelector, app => app.editStatus || DEFAULT);

const isNewStatus = createSelector(editStatus, edit => edit === DEFAULT);

export default editStatus;
export { isNewStatus };
